import { render, staticRenderFns } from "./GalleryMediaItem.vue?vue&type=template&id=22f4769d&scoped=true&"
import script from "./GalleryMediaItem.vue?vue&type=script&lang=js&"
export * from "./GalleryMediaItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryMediaItem.vue?vue&type=style&index=0&id=22f4769d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4769d",
  null
  
)

export default component.exports